module.exports = __webpack_public_path__ + "media/images/flags/be-5bd44ee63d52881e1a401f7464a6e268.svg";